import React from 'react';
import {
	styled,
	ParentBoundComponent,
	Module,
	Button,
	webapi
} from 'ps-gui';

import MainPageModel from './mainpagemodel';
import PageMenu from '../blocks/pagemenu';
import {
	getNumPhrase,
	getPhrase
} from '../data/phrases';
import { withGlobalContext } from '../data/globalcontext';
import Message from '../blocks/message';
import { formatHtml } from './utils';
import { pushState } from '../data/history';

const Wrapper = styled.div`
	padding: 0px 100px;
	@media (max-width: 1600px) {
		padding: 0px 28px;
	}
	@media (max-width: 1500px) {
		padding: 0px 18px;
	}
	@media (max-width: 1400px) {
		padding: 0px 8px;
	}
`;

const LogoutMessageButtons = styled.div`
	text-align: right;
`;

const LogoutMessageText = styled.div`
	margin: 4px;
`;

class MainPageModule extends ParentBoundComponent {

	constructor() {
		super();
		this.setSelectedModuleId = this.setSelectedModuleId.bind(this);
		this.touch = this.touch.bind(this);
		this.onMaintenanceNotificationClose = this.onMaintenanceNotificationClose.bind(this);
	}

	onMaintenanceNotificationClose() {
		this.props.globalContext.closeMaintenanceNotification().apply();
	}

	touch() {
		webapi.execute('/api/proc/api_user/touch');
	}

	setSelectedModuleId(moduleId) {
		pushState(moduleId, '');
		this.setModel(this.getModel().setSelectedModuleId(moduleId));
	}

	getModel() {
		return new MainPageModel(this.getData());
	}

	setModel(model) {
		this.setData(model.getData());
	}

	componentDidMount() {
		if (!this.getData().get('initialized')) {
			const globalContext = this.props.globalContext;
			this.setModel(this.getModel().initialize(globalContext));
			pushState(this.getData().get('selectedModuleId'));
		}
	}

	renderLogoutIn(seconds, maintenance) {
		const minutes = Math.ceil(seconds / 60);
		return (
			<Message valign="top">
				<LogoutMessageText>
					{getPhrase('sessionLogoutInLessThan')} <b>{minutes}</b> {getNumPhrase('minutes', minutes)}.
				</LogoutMessageText>
				{
					!maintenance &&
					<LogoutMessageButtons>
						<Button
							type="light"
							text={getPhrase('stayLoggedIn')}
							onAction={this.touch}
						/>
					</LogoutMessageButtons>

				}
			</Message>
		);
	}

	renderMaintenanceNotification() {
		const globalContext = this.props.globalContext;
		const day = globalContext.getMaintenanceDay();
		if (!day) {
			return null;
		}
		const timeFrom = globalContext.getMaintenanceTimeFrom();
		const timeTo = globalContext.getMaintenanceTimeTo();
		const msg = getPhrase('maintenanceNotification').replace('$day', day).replace('$timeFrom', timeFrom).replace('$timeTo', timeTo);
		return (
			<Message maxWidth="570px" onClose={this.onMaintenanceNotificationClose}>
				<span dangerouslySetInnerHTML={{ __html: formatHtml(msg) }} />
			</Message>
		);
	}

	renderNotifications() {
		const notifications = this.props.globalContext.getNotifications();
		if (!notifications || notifications.size === 0) {
			return null;
		}
		return notifications.map(notification => {
			const id = notification.get('id');
			return (
				<Message
					maxWidth="570px"
					key={id}
					onClose={() => {
						this.props.globalContext.closeNotification(id).apply();
					}}
				>
					<span dangerouslySetInnerHTML={{ __html: formatHtml(notification.get('text')) }} />
				</Message>
			);
		});
	}

	render() {
		const data = this.getData();
		const selectedModuleId = data.get('selectedModuleId');
		const modulePath = ['module', selectedModuleId];
		const globalContext = this.props.globalContext;
		const logoutIn = globalContext.getLogoutIn();
		return (
			<Wrapper>
				<PageMenu
					leftMenuItems={data.get('leftMenuItems')}
					rightMenuItems={data.get('rightMenuItems')}
					selectedModuleId={selectedModuleId}
					onModuleSelected={this.setSelectedModuleId}
				/>
				{
					logoutIn > 0 ? this.renderLogoutIn(logoutIn, globalContext.getMaintenance()) : this.renderMaintenanceNotification()
				}
				{
					this.renderNotifications()
				}
				<Module
					appState={data.getIn(modulePath)}
					onDataChange={newData => {
						this.setData(data.setIn(modulePath.concat('data'), newData));
					}}
				/>
			</Wrapper>
		);
	}
}

export default withGlobalContext(MainPageModule);
